const flags = (window.flags = {
  ads: {
    disableAds: 'Hide external ads (prevent error logs if using AdBlock)',
    realAds: 'Force real ads',
    testAds: 'Force test ads (if realAds is not set)',
  },
  user: {
    confirmationModal: 'Show email confirmation modal',
    guest: 'Logout and remain as guest',
    email: 'Login with specific email',
    user: 'Login with specific user (0 - default, 1 - trial, 2 - gold, 3 - vip)',
  },
  labels: {
    logUsedLabels: 'Save used labels in `usedLabels`. Afterwards you can call `checkMissingLabels()`.',
    showLabelNames: 'Show label keys instead of values. Hover over to see full location.',
  },
  misc: {
    reduxLogger: 'Turn on Redux Logger (for non-localhost envs)',
    vip: 'Enable VIP as an upgrade option',
    randomRatings: 'Use randomised age ratings (for easy testing)',
    gaTracker: 'Supply a tracker ID to test whether data is received',
    gaDebug: 'Print useful output in the console related to GA',
  },
  theme: {
    theme: 'Choose theme',
    themeEditor: 'Customize theme and export as json',
    themePreview: 'Add color palette (for PA preview images)',
  },
  messages: {
    fakeCCP: 'Use specific credentials to see a CCP widget regardless of the user',
    disableCCP: 'Disable CCP',
    disableNotifications: 'Disable notifications (which clog up the logs)',
    mailbox: 'Show mailbox UI (used by old niches)',
  },
})

window.help = () => {
  const entry = ([key, value]) => '  ' + key.padEnd(25, '.') + value
  const group = (name, entries) => name + '\n' + entries.map(entry).join('\n')
  console.warn(
    Object.keys(flags)
      .map(name => group(name, Object.entries(flags[name])))
      .join('\n\n')
  )
}

export default flags
